import { useComfort } from "../ComfortContext";
import { getDictionary } from "../../i18n/dictionary";

/**
 * Sync framing for progress surfaces (brief §4): a "last synced" indicator plus
 * the offline-first caveat that figures are consented engagement summaries that
 * may lag. `at` is the most recent session ISO time, if any.
 */
export function SyncNote({ at }: { at?: string }) {
  const { locale } = useComfort();
  const t = getDictionary(locale).service.sync;
  const when = at
    ? new Date(at).toLocaleDateString(locale === "ms" ? "ms-MY" : "en-GB", {
        day: "numeric",
        month: "short",
      })
    : null;

  return (
    <p
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        fontSize: 12.5,
        color: "var(--ink-faint)",
        margin: 0,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          background: "var(--good)",
          flex: "none",
        }}
      />
      <span>
        <b style={{ fontWeight: 600 }}>
          {t.lastSynced}
          {when ? ` ${when}` : ""}
        </b>{" "}
        · {t.note}
      </span>
    </p>
  );
}
